module.exports = __webpack_public_path__ + "img/loterica.ecc4a34f.png";